module.exports = __webpack_public_path__ + "static/media/mapa.1a02ff06.svg";